import MenuItem from './MenuItem';
import PersonIcon from '@mui/icons-material/Person';
import HomeIcon from '@mui/icons-material/Home';
import WebIcon from '@mui/icons-material/Web';
const MenuDetails = () => {

    const menuItems = [
        { icon: <WebIcon />, title: 'وبسایت هاشین گلد', internalLink: null, url: 'https://hashingold.com' },
        { icon: <PersonIcon />, title: 'معرفی به دوستان', internalLink: null, url: 'https://hashingold.com' },
        { icon: <HomeIcon />, title: 'درباره هاشین', internalLink: null, url: 'https://hashingold.com/about' },
    ];

    return (
        <div>
            {menuItems.map((item, index) => (
                <MenuItem
                    key={index}
                    icon={item.icon}
                    title={item.title}
                    internalLink={item.internalLink}
                    url={item.url}
                />
            ))}
        </div>
    );
};

export default MenuDetails;
